module.exports = __webpack_public_path__ + "static/media/confirm-changes.faf5f36a.svg";